<script setup>
import { Loc } from 'main.core';
import { computed } from 'ui.vue3';
import { storeToRefs } from 'ui.vue3.pinia';
import useCalculatorStore from '../../../../store/calculator.js';

const calculator = useCalculatorStore();
const { selectedTariff, tariffs } = storeToRefs(calculator);
const selectedTariffName = computed(() => tariffs.value.find(t => t.id === selectedTariff.value)?.name);
</script>

<template>
  <p class="cloud-calculator__summary-label" v-if="selectedTariffName">
    {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_LABEL_TARIFF') }}: {{ selectedTariffName }}
  </p>
</template>
